<template>
  <div v-if="show" class="twoThird" :style="`zIndex:${zindex}`">
    <div class="closebtn" @click.stop="show = false">X</div>
    <radishList
      :show-search="true"
      :company="toshowcompany"
      :department="toshowdepartment"
      :group="toshowgroup"
      :departments="departments"
    ></radishList>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      toshowcompany: '',
      toshowdepartment: '',
      toshowgroup: '',
      departments: [],
    }
  },
  methods: {
    open({ company, department, group }) {
      this.toshowdepartment = department
      this.toshowcompany = company
      this.toshowgroup = group
      this.getDepartments(company)
      this.show = true
      this.zindex = app.root.dragindex++
    },
    async getDepartments(company) {
      const result = await window.app.service('company').getDepartments(company)
      if (result.status === 'success') this.departments = result.data
    },
  },
}
</script>
<style scoped>
.twoThird {
  position: absolute;
  top: 60px;
  right: 0;
  width: 66vw;
  height: 100vh;
  padding-left: 10px;
  background-color: #fff;
  border: 1px solid #eee;
  box-shadow: -3px 4px 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
  z-index: 1002;
}
.closebtn {
  width: 28px;
  height: 28px;
  color: #fff;
  background-color: #f56c6c;
  border-radius: 50%;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: absolute;
  top: 0;
  right: 20px;
  z-index: 4;
}
</style>
